// Shared styling for the auth pages (used inside AuthLayout). Theme-aware:
// light base + dark: variants, following ThemeContext like the landing page.
// Kept as constants so the six auth pages stay visually identical without
// copy-pasting utility strings.
//
// NOTE: BusinessSetupPage also consumes these constants but pins itself to the
// dark look by putting `dark` on its root element — keep both variants intact.

export const authLabel = "block text-sm font-medium text-slate-700 dark:text-slate-300";

// Margin-less variant for layouts that manage their own field spacing (e.g.
// BusinessSetupPage's icon-overlay inputs, where a margin on the input itself
// would offset the absolutely-centered icon).
export const authInputBase =
  "block w-full rounded-xl bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 ring-1 ring-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500/70 transition-shadow dark:bg-white/5 dark:text-white dark:placeholder:text-slate-500 dark:ring-white/10";

export const authInput = `mt-1 ${authInputBase}`;

export const authPrimaryBtn =
  "w-full rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 hover:from-blue-400 hover:to-indigo-500 px-4 py-2.5 text-sm font-semibold text-white shadow-lg shadow-blue-500/30 disabled:opacity-50 disabled:cursor-not-allowed transition-all";

export const authSecondaryBtn =
  "w-full rounded-xl bg-slate-100 px-4 py-2.5 text-sm font-semibold text-slate-700 ring-1 ring-slate-200 hover:bg-slate-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors dark:bg-white/5 dark:text-slate-100 dark:ring-white/10 dark:hover:bg-white/10";

export const authFormError =
  "rounded-xl bg-rose-50 px-4 py-3 text-sm text-rose-700 ring-1 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-200 dark:ring-rose-500/30";

export const authFieldError = "mt-1 text-xs text-rose-600 dark:text-rose-300";

export const authMuted = "text-slate-500 dark:text-slate-400";

export const authLink =
  "font-medium text-blue-600 underline hover:text-blue-700 dark:text-blue-300 dark:hover:text-blue-200";
